import React from 'react'

const LogoWhite = () => {
    return (
        <img src="/images/lacnic40-logo.svg" alt="LACNIC 40"></img>
    )
}

export default LogoWhite
